import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import {
  FiLogOut,
  FiUsers,
  FiSettings,
  FiHelpCircle,
  FiFileText,
  FiList,
  FiCalendar,
  FiMessageSquare,
  FiGrid
} from "react-icons/fi";
import classes from "./Sidebar.module.css";
import logo from '../../Assets/userlogo.png';
import LogoutModal from './logoutModal';

const Sidebar = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();

  const handleLogoutClick = (e) => {
    e.preventDefault();
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    setShowLogoutModal(false);
    // Optional: clear auth tokens here
    navigate("/sign");
  };

  return (
    <div className={classes.sidebar}>
      <div className={classes.logoSection}>
        <Link to={'/'} ><img src={logo} alt="OGIRS Logo" className={classes.logo} /></Link>
      </div>
      <div className={classes.navWrapper}>
        <nav className={classes.nav}>
          <NavLink to="/dashboard" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiGrid />
            <span>Dashboard</span>
          </NavLink>
          {/* <NavLink to="/employees" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiUsers />
            <span>Employees</span>
          </NavLink>
          <NavLink to="/transactions" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiCalendar />
            <span>Transactions</span>
          </NavLink>
          <NavLink to="/stamp-duty" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiList />
            <span>Stamp Duty</span>
          </NavLink>
          <NavLink to="/filings-returns" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiFileText />
            <span>Fillings & Returns</span>
          </NavLink>
          <NavLink to="/tax-clearance" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiMessageSquare />
            <span>Tax Clearance</span>
          </NavLink>
          <NavLink to="/generate-bill" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiMessageSquare />
            <span>Generate Bill</span>
          </NavLink>

          

          <NavLink to="/support" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiHelpCircle />
            <span>Support</span>
          </NavLink>
          <NavLink to="/settings" className={({ isActive }) => `${classes.link} ${isActive ? classes.active : ""}`}>
            <FiSettings />
            <span>Settings</span>
          </NavLink> */}
          <hr className={classes.divider} />

          {/* Logout is a custom clickable item, not a NavLink */}
          <a href="/logout" onClick={handleLogoutClick} className={`${classes.link} ${classes.logout}`}>
            <FiLogOut />
            <span>Logout</span>
          </a>
        </nav>

        {showLogoutModal && (
          <LogoutModal
            onClose={() => setShowLogoutModal(false)}
            onConfirm={confirmLogout}
          />
        )}
      </div>
    </div>
  );
};

export default Sidebar;
